import React, { useEffect } from "react";
import Select from "../../UI/Inputs/Select/Select";
import SelectItem from "../../UI/Inputs/Select/SelectItem";

export default function SeriesSelect({ student, methods }) {
  const selectedSeries = methods.watch("series_id");
  const courseEnrollments = student?.course_enrollments?.filter(
    (enrollment) => !enrollment.orphaned
  );
  const seminarEnrollments = student?.seminar_enrollments?.filter(
    (enrollment) => !enrollment.orphaned
  );

  useEffect(() => {
    if (student) {
      const selectedEnrollmentId = [
        ...student.course_enrollments,
        ...student.seminar_enrollments,
      ].find((enrollment) => enrollment.series_id === selectedSeries)?.id;

      methods.setValue("selected_enrollment_id", selectedEnrollmentId);
    }
  }, [student, selectedSeries]);

  return (
    <Select
      id="series_id"
      classNames="w-full bg-transparent"
      label="Course / Seminar"
      isRequired
    >
      <SelectItem value="">Select</SelectItem>
      {courseEnrollments?.length > 0 && (
        <optgroup label="Courses">
          {courseEnrollments?.map((enrollment) => (
            <SelectItem key={enrollment.id} value={enrollment.series_id}>
              {enrollment.series_name}
            </SelectItem>
          ))}
        </optgroup>
      )}
      {seminarEnrollments?.length > 0 && (
        <optgroup label="Seminars">
          {seminarEnrollments?.map((enrollment) => (
            <SelectItem key={enrollment.id} value={enrollment.series_id}>
              {enrollment.series_name}
            </SelectItem>
          ))}
        </optgroup>
      )}
    </Select>
  );
}
